export default "__VITE_ASSET__CuPaIr5P__"